export default "__VITE_ASSET__BmQJrMjQ__";